import { motion } from 'framer-motion';

const Marquee = ({ text }: { text: string }) => {
  const repeated = Array(6).fill(text).join('');

  return (
    <div className="overflow-hidden py-5 border-y border-border/50">
      <motion.div
        className="whitespace-nowrap flex"
        animate={{ x: ['0%', '-50%'] }}
        transition={{ duration: 40, repeat: Infinity, ease: 'linear' }}
      >
        <span className="font-body text-[11px] tracking-[0.3em] text-muted-foreground/60 uppercase">
          {repeated}
        </span>
      </motion.div>
    </div>
  );
};

export default Marquee;
